import { Nav } from 'react-bootstrap';
import { PlansResponse } from '../../types/Interface/Plan';
import { getMonthlyPrice } from '../../helpers/Utils';

/**
 * Reusable component to display the details for a single plan.
 *
 * @param {Plan} plan - The plan object containing the details to display.
 * @returns {JSX.Element} The rendered plan details.
 */
const PlanDetails: React.FC<{ tabkey: string; tabIndex: number; eventKey: string; plan: PlansResponse; handleRedirect: (url: string) => void }> = ({
	tabkey,
	tabIndex,
	eventKey,
	plan,
	handleRedirect,
}) => {
	return (
		<>
			<Nav.Item>
				<Nav.Link eventKey={eventKey}>
					<div className="single-tab-tab">
						<div className="single-box-tab-tab">
							{tabkey?.toLocaleLowerCase().includes('year') && tabIndex === 2 && <span className="best-value-box">Best Value</span>}

							<div className="inner-single-box-tab">
								<div className="pricing-plan-name">
									<h6>{plan.name}</h6>
									{plan.usdPrice && (
										<div className="pricing-plan-price">
											<h5>
												{/* $ */}
												<svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="50px" height="40px" viewBox="0 0 1024 1024">
													<path d="M541.7 768v-45.3c46.3-2.4 81.5-15 108.7-37.8 27.2-22.8 40.8-53.1 40.8-88.2 0-37.8-11-65.7-35.3-83.4-24.6-20.1-59.8-35.4-111.6-45.3h-2.6V351.8c35.3 5.1 65.3 15 95.1 35.4l43.6-55.5c-43.6-27.9-89.9-42.9-138.8-45.3V256h-40.8v30.3c-40.8 2.4-76.3 15-103.5 37.8-27.2 22.8-40.8 53.1-40.8 88.2s11 63 35.3 80.7c21.7 17.7 59.8 32.7 108.7 42.9v118.5c-38.2-5.1-76.3-22.8-114.2-53.1l-48.9 53.1c48.9 40.5 103.5 63 163.3 68.1V768h41zm2.6-219.6c27.2 7.5 43.6 15 54.4 22.8 8.1 10.2 13.6 20.1 13.6 35.4s-5.5 25.2-19.1 35.4c-13.6 10.2-30.1 15-48.9 17.7V548.4zM449.2 440c-8.1-7.5-13.6-20.1-13.6-32.7 0-15 5.5-25.2 16.2-35.4 13.6-10.2 27.2-15 48.9-17.7v108.6c-27.2-7.8-43.4-15.3-51.5-22.8z" />
												</svg>
												{plan.usdPrice}
												{plan.name === 'On Demand' ? '/GB' : ''}
											</h5>
										</div>
									)}
								</div>
								<div className="btns-and-list-tabs">
									<ul>
										{plan.name === 'On Demand' ? (
											<>
												<li>
													<label>
														<svg fill="none" height="13" viewBox="0 0 16 13" width="16" xmlns="http://www.w3.org/2000/svg">
															<path
																d="M1 6.72494L5.66667 11.3916L15 1.3916"
																// fill="white"
																stroke="#EFBD8A"
																strokeLinecap="round"
																strokeLinejoin="round"
																strokeWidth="2"
															/>
														</svg>
														Scale instantly anytime
													</label>
												</li>
												<small className="month-approx">(Flexible pricing for growing storage needs.)</small>
											</>
										) : (
											<>
												<li>
													<label>
														<svg fill="none" height="13" viewBox="0 0 16 13" width="16" xmlns="http://www.w3.org/2000/svg">
															<path
																d="M1 6.72494L5.66667 11.3916L15 1.3916"
																// fill="white"
																stroke="#EFBD8A"
																strokeLinecap="round"
																strokeLinejoin="round"
																strokeWidth="2"
															/>
														</svg>
														Upload Quota
													</label>
													<span>{plan.data}</span>
												</li>
												<small className="month-approx">(Approx. ${getMonthlyPrice(plan.usdPrice, plan.data)}/GB)</small>
											</>
										)}
									</ul>
									<a
										href="javascript:void(0)"
										onClick={(e) => {
											e.preventDefault();
											handleRedirect(`${process.env.REACT_APP_STREAMEFY + '/?tabId=0'}`);
										}}
										className="cmn-btn btn-price-area"
									>
										<span>
											<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path
													d="M8.2821 16L15.7819 8.52686C15.9216 8.38684 16 8.19743 16 8C16 7.80257 15.9216 7.61316 15.7819 7.47314L8.2821 -3.3736e-07L7.22462 1.05371L13.442 7.24895L-3.16862e-07 7.24895L-3.82194e-07 8.74358L13.442 8.74358L7.22462 14.9388L8.2821 16Z"
													fill="white"
												></path>
											</svg>
											start free trial
										</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</Nav.Link>
			</Nav.Item>
		</>
	);
};

export default PlanDetails;
